import mongoose from 'mongoose'

export const expensesSchema = mongoose.Schema({
	category:{
		type:mongoose.Schema.Types.ObjectId,
		ref:"Categories"
	},
	amount:{
		type:Number,
		required:true 
	},
	user:{
		type:mongoose.Schema.Types.ObjectId,
		ref:"User"
	}
},{collection:"expenses"});
export default  mongoose.model("Expenses",expensesSchema)
